export const ComponentTypes = {
    AddressInput: 'wixui.AddressInput',
    Anchor: 'wysiwyg.common.components.anchor.viewer.Anchor',
    AppController: 'platform.components.AppController',
    AppWidget: 'platform.components.AppWidget',
    BackToTopButton: 'wysiwyg.viewer.components.BackToTopButton',
    BoxSlideShow: 'wysiwyg.viewer.components.BoxSlideShow',
    BoxSlideShowSlide: 'wysiwyg.viewer.components.BoxSlideShowSlide',
    Checkbox: 'wysiwyg.viewer.components.inputs.Checkbox',
    CheckboxGroup: 'wysiwyg.viewer.components.inputs.CheckboxGroup',
    ClassicFooter: 'wysiwyg.viewer.components.FooterContainer',
    ClassicHeader: 'wysiwyg.viewer.components.HeaderContainer',
    ClassicSection: 'wysiwyg.viewer.components.ClassicSection',
    Column: 'wysiwyg.viewer.components.Column',
    ComboBoxInput: 'wysiwyg.viewer.components.inputs.ComboBoxInput',
    Container: 'mobile.core.components.Container',
    CustomElement: 'wixui.CustomElementComponent',
    DatePicker: 'wysiwyg.viewer.components.inputs.DatePicker',
    DocumentButton: 'wysiwyg.viewer.components.documentmedia.DocumentMedia',
    DropDownMenu: 'wysiwyg.viewer.components.menus.DropDownMenu',
    ExpandableMenu: 'wysiwyg.viewer.components.ExpandableMenu',
    FacebookComment: 'wysiwyg.viewer.components.WFacebookComment',
    FacebookLike: 'wysiwyg.viewer.components.WFacebookLike',
    FacebookPageLike: 'wysiwyg.common.components.facebooklikebox.viewer.FacebookLikeBox',
    FacebookShare: 'wysiwyg.viewer.components.FacebookShare',
    FileUploader: 'wysiwyg.viewer.components.inputs.FileUploader',
    FiveGridLine: 'wysiwyg.viewer.components.FiveGridLine',
    FooterSection: 'responsive.components.FooterSection',
    FormContainer: 'wysiwyg.viewer.components.FormContainer',
    GhostRefComponent: 'GHOST_REF_COMP',
    GoogleMap: 'wysiwyg.viewer.components.GoogleMap',
    Group: 'wysiwyg.viewer.components.Group',
    HeaderSection: 'responsive.components.HeaderSection',
    HtmlEmbed: 'wysiwyg.viewer.components.HtmlComponent',
    ImageButton: 'wysiwyg.common.components.imagebutton.viewer.ImageButton',
    ImageX: 'wixui.ImageX',
    ItunesButton: 'wysiwyg.viewer.components.ItunesButton',
    LanguageSelector: 'wysiwyg.viewer.components.LanguageSelector',
    LineShareButton: 'wixui.LineShareButton',
    LinkBar: 'wysiwyg.viewer.components.LinkBar',
    List_DEPRACATED: 'wixapps.integration.components.AppPart2',
    LoginSocialBar: 'wysiwyg.viewer.components.LoginSocialBar',
    LottieEmbed: 'wixui.LottieEmbed',
    Masonry: 'tpa.viewer.components.Masonry',
    MasterPage: 'mobile.core.components.MasterPage',
    MatrixGallery: 'wysiwyg.viewer.components.MatrixGallery',
    MediaContainer: 'wysiwyg.viewer.components.MediaContainer',
    MediaControls: 'wysiwyg.viewer.components.MediaControls',
    MediaOverLayControls: 'wysiwyg.viewer.components.MediaOverlayControls',
    MembersAreaSection: 'responsive.components.MembersAreaSection',
    MenuContainer: 'wysiwyg.viewer.components.MenuContainer',
    MenuToggle: 'wysiwyg.viewer.components.MenuToggle',
    MusicPlayer: 'wixui.MusicPlayer',
    Page: 'mobile.core.components.Page',
    PagesContainer: 'wysiwyg.viewer.components.PagesContainer',
    PageGroup: 'wysiwyg.viewer.components.PageGroup',
    PaginatedGridGallery: 'wysiwyg.viewer.components.PaginatedGridGallery',
    Pagination: 'wixui.Pagination',
    PaypalButton: 'wysiwyg.viewer.components.PayPalButton',
    PinterestFollow: 'wysiwyg.viewer.components.PinterestFollow',
    PinterestPinIt: 'wysiwyg.common.components.pinterestpinit.viewer.PinterestPinIt',
    PinterestShare: 'wysiwyg.common.components.pinitpinwidget.viewer.PinItPinWidget',
    PopupCloseButton: 'wysiwyg.viewer.components.PopupCloseTextButton',
    PopupCloseIconButton: 'wysiwyg.viewer.components.PopupCloseIconButton',
    PopupContainer: 'wysiwyg.viewer.components.PopupContainer',
    ProgressBar: 'wixui.ProgressBar',
    QuickActionBar: 'wysiwyg.viewer.components.QuickActionBar',
    RadioGroup: 'wysiwyg.viewer.components.inputs.RadioGroup',
    RatingsDisplay: 'wixui.RatingsDisplay',
    RefComponent: 'wysiwyg.viewer.components.RefComponent',
    RemoteRefDeadComponent: 'REMOTE_REF_DEAD_COMP',
    Repeater: 'wysiwyg.viewer.components.Repeater',
    RichText: 'wysiwyg.viewer.components.WRichText',
    SearchBox: 'wixui.SearchBox',
    Section: 'responsive.components.Section',
    SelectionTags: 'wixui.SelectionTagsList',
    SignatureInput: 'wixui.SignatureInput',
    SiteButton: 'wysiwyg.viewer.components.SiteButton',
    SiteRegionContainer: 'wysiwyg.viewer.components.SiteRegionContainer',
    Slider: 'wixui.Slider',
    SliderShowGallery: 'wysiwyg.viewer.components.SlideShowGallery',
    SlotsPlaceholder: 'wixui.SlotsPlaceholder',
    StateBox: 'wysiwyg.viewer.components.StateBox',
    StateBoxFormState: 'wysiwyg.viewer.components.StateBoxFormState',
    StripColumnsContainer: 'wysiwyg.viewer.components.StripColumnsContainer',
    StripSlideShow: 'wysiwyg.viewer.components.StripContainerSlideShow',
    StripSlideShowSlide: 'wysiwyg.viewer.components.StripContainerSlideShowSlide',
    StylableButton: 'wixui.StylableButton',
    StylableHorizontalMenu: 'wixui.StylableHorizontalMenu',
    Switch: 'wixui.ToggleSwitch',
    Tables: 'wysiwyg.viewer.components.Grid',
    TextArea: 'wysiwyg.viewer.components.inputs.TextAreaInput',
    TextAreaInput: 'wysiwyg.viewer.components.inputs.TextAreaInput',
    TextInput: 'wysiwyg.viewer.components.inputs.TextInput',
    TimePicker: 'wixui.TimePicker',
    TinyMenu: 'wysiwyg.viewer.components.mobile.TinyMenu',
    TpaGluedWidget: 'wysiwyg.viewer.components.tpapps.TPAGluedWidget',
    TpaMultiSection: 'wysiwyg.viewer.components.tpapps.TPAMultiSection',
    TpaSection: 'wysiwyg.viewer.components.tpapps.TPASection',
    TpaStripSlideShow: 'tpa.viewer.components.StripSlideshow',
    TpaWidget: 'wysiwyg.viewer.components.tpapps.TPAWidget',
    TwitterFollow: 'wysiwyg.viewer.components.WTwitterFollow',
    TwitterTweet: 'wysiwyg.viewer.components.WTwitterTweet',
    VKShareButton: 'wysiwyg.viewer.components.VKShareButton',
    VectorImage: 'wysiwyg.viewer.components.VectorImage',
    VerticalAnchorsMenu: 'wysiwyg.common.components.verticalanchorsmenu.viewer.VerticalAnchorsMenu',
    VerticalLine: 'wysiwyg.viewer.components.VerticalLine',
    VerticalMenu: 'wysiwyg.common.components.verticalmenu.viewer.VerticalMenu',
    VideoBox: 'wysiwyg.viewer.components.MediaPlayer',
    VideoPlayer: 'wixui.VideoPlayer',
    WPhoto: 'wysiwyg.viewer.components.WPhoto',
    YoutubeSubscribe: 'wysiwyg.common.components.youtubesubscribebutton.viewer.YouTubeSubscribeButton',
    reCAPTCHA: 'wixui.Captcha',
};
//# sourceMappingURL=componentTypes.js.map